// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__+L5vt","white":"Checkbox_white__tp-3K","label":"Checkbox_label__TOTc3","round":"Checkbox_round__wqnkN"};